module.exports = __webpack_public_path__ + "img/4-10vialation.30da19cd.png";